import { axiosInstance } from "api/axios.instance"
import type { TChangePassword } from "types/user.type"

class UserService {
	static BASE_URL = "users"

	async getUserProfile() {
		return axiosInstance.get(`${UserService.BASE_URL}/profile`)
	}

	async getUsers() {
		return axiosInstance.get(UserService.BASE_URL)
	}

	async changeUserRole(id: number, newRole: string) {
		return axiosInstance.post(`${UserService.BASE_URL}/${id}/role`, { newRole })
	}

	async inviteUser() {
		return axiosInstance.post("registration/token")
	}

	async changeUserStatus(id: number, newStatus: string) {
		return axiosInstance.post(`${UserService.BASE_URL}/${id}/state`, { state: newStatus })
	}

	async changePassword(data: TChangePassword) {
		return axiosInstance.post(`${UserService.BASE_URL}/set_password/`, {
			new_password: data.password,
			re_new_password: data.confirmPassword,
			current_password: data.currentPassword,
		})
	}

	async deleteUser(id: number, password: string) {
		return axiosInstance.delete(`${UserService.BASE_URL}/${id}/delete`, {
			headers: { "Admin-Password": password },
		})
	}

	async getNatsCreds() {
		return axiosInstance.get(`${UserService.BASE_URL}/nats_creds/`)
	}
}

export default new UserService()
